import { CAL_EVENT_GRACE_HOURS } from './cal-event-grace-hours.js';
export function templateFieldGraceHours(config) {
    return config?.graceHours ?? CAL_EVENT_GRACE_HOURS.default;
}
//# sourceMappingURL=template-field-grace-hours.js.map